import React from 'react';
import { arrayOf, shape, string, bool, number } from 'prop-types';
import cx from 'classnames';

import { Button, ButtonToggle, Bar, BarItem } from '../../components';

const propTypes = {
  items: arrayOf(
    shape({
      id: number,
      link: string,
      section: string,
      title: string,
    }).isRequired
  ),
  listClassName: string,
  isMobile: bool,
  toggleData: string,
};

const CLASS_ROOT = 'main-nav';

class MainNav extends React.Component {
  static displayName = 'MainNav';

  constructor(props) {
    super(props);
    this.instance = null;
    this.navRef = React.createRef();

    this.state = {};

    return this;
  }

  render() {
    const {
      className,
      children,
      listClassName,
      items,
      isMobile,
      toggleData,
      ...other
    } = this.props;

    const classes = cx(
      CLASS_ROOT,
      {
        [`${CLASS_ROOT}--mobile`]: isMobile,
      },
      className
    );

    const Tag = isMobile ? ButtonToggle : Button;

    return (
      <nav
        id="page-navigation"
        ref={c => {
          this.navRef = c;
        }}
        className={classes}
        {...other}
      >
        <Bar
          tag="ul"
          nowrap
          direction={isMobile ? 'vertical' : 'horizontal'}
          className={cx('list--unstyled', listClassName)}
        >
          {items.map(
            ({
              id,
              link,
              title,
              section,
              className: itemClassName,
              srOnly,
              ...itemOther
            }) => (
              <BarItem tag="li" className="mt-none" key={id}>
                <Tag
                  {...(isMobile
                    ? { 'data-toggle': toggleData, size: 'small' }
                    : {})}
                  type="link"
                  href={link}
                  data-section={section}
                  className={cx('mb-none', itemClassName)}
                  {...itemOther}
                >
                  {title}
                </Tag>
              </BarItem>
            )
          )}
        </Bar>
      </nav>
    );
  }
}
MainNav.propTypes = propTypes;

export default MainNav;



// WEBPACK FOOTER //
// ./src/components/MainNav/MainNav.js